// eslint-disable-next-line
import React, { Fragment } from 'react';
import { useQuery } from '@apollo/client';
import { ROCKET_QUERY } from '../lib/queries';
import ImageSlider from "./ImageSlider";
import { useParams } from "react-router";
import { Link } from 'react-router-dom';

import classNames from 'classnames';

export default function Rocket() {
    const { id: rocketId } = useParams();

    const { loading, error, data } = useQuery(ROCKET_QUERY, {
        variables: { rocketId },
    });
    // console.log(data);

    if (loading) return (
        <Fragment>
            <div className="spinner-grow spinner-grow-sm"></div>
            <div className="spinner-grow spinner-grow-sm"></div>
            <div className="spinner-grow spinner-grow-sm"></div>
            <div className="spinner-grow spinner-grow-sm"></div>
        </Fragment>
    );

    if (error) return `Error! ${error.message}`;

    const {
        name,
        type,
        active,
        stages,
        boosters,
        cost_per_launch,
        success_rate_pct,
        first_flight,
        country,
        company,
        wikipedia,
        description,
        flickr_images
    } = data.rocket

    return (
        <div>
            <div className="mb-3" style={{ display: 'flex', flexDirection: 'row', alignContent: 'flex-end', alignItems: 'flex-end' }}>
                <h1 className="display-4 my-3">
                    <span className="text-dark">{name}</span>
                </h1>
            </div>
            <h4 className="mb-3">Rocket Details</h4>
            <ul className="list-group">
                <li className="list-group-item opacity-4">
                    Rocket active: &#32;{''}
                    <span
                        className={classNames({
                            'text-success': active,
                            'text-danger': !active
                        })}
                    >
                        {active ? 'Yes' : 'No'}
                    </span>
                </li>
                <li className="list-group-item opacity-5">
                    Description: {''}{description}
                </li>
                <li className="list-group-item opacity-4">
                    Company: {''}{company}
                </li>
                <li className="list-group-item opacity-5">
                    Country: {''}{country}
                </li>
                <li className="list-group-item opacity-4">
                    Rocket type: {''}{type}
                </li>
                <li className="list-group-item opacity-5">
                    Stages: {''}{stages}
                </li>
                <li className="list-group-item opacity-4">
                    Boosters: {''}{boosters}
                </li>
                <li className="list-group-item opacity-5">
                    Cost per Launch: {''}{cost_per_launch} $
                </li>
                <li className="list-group-item opacity-4">
                    Succes rate purcentage: {''}
                    <span
                        className={classNames({
                            'text-success': success_rate_pct>50,
                            'text-danger': success_rate_pct<50
                        })}
                    >
                        {success_rate_pct} %
                    
                    </span>
                </li>
                <li className="list-group-item opacity-5">
                    First flight: {''}{first_flight}
                </li>
                <li className="list-group-item text-truncate opacity-4">
                    Wikipedia: &#32;<a target="_blank"
                        rel="noreferrer noopener"
                        href={wikipedia}
                        title="(open in a new tab)"
                    >
                        &#32;{wikipedia} </a>
                </li>
            </ul>
            <div>
                <ImageSlider
                    srcArr={flickr_images.concat(flickr_images)}
                />
            </div>
            <Link to="/" className="list-group-item shadow-sm btn btn-secondary opacity-4">Home</Link>
            <hr />
        </div>
    );
};